module.exports = __webpack_public_path__ + "static/media/evolution-image-mobile.5564d834.png";